// Constants.
import * as LMSConstants from 'constants/LMSConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';


const initialState = {
  isFetching: false,
  isFetched: false,
  courses: [],
  errorMessage: '',
};

export default function config(state = initialState, action = {}) {
  switch (action.type) {
    case LMSConstants.LOAD_LMS_COURSES_REQUEST:
      return {
        ...state,
        isFetched: false,
        isFetching: true,
      };
    case LMSConstants.LOAD_LMS_COURSES_SUCCESS:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        courses: action.courses,
      };
    case LMSConstants.LOAD_LMS_COURSES_FAILURE:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        courses: null,
        errorMessage: action.message,
      };
    case LMSConstants.UPDATE_LMS_COURSE_MATERIAL_REQUEST: {
      const courses = { ...state.courses };
      if (action.material.state === 4 && courses[`_${action.material.course}`] !== undefined) {
        courses[`_${action.material.course}`].materials_finished += 1;
      }
      return {
        ...state,
        courses: courses,
      };
    }
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetched: false,
        isFetching: false,
        courses: null,
        errorMessage: '',
      };
    default:
      return state;
  }
}
